import { CommonModule } from '@angular/common';
import { Component, AfterViewInit, ElementRef, Renderer2, ViewChild, OnInit } from '@angular/core';
import { HttpService } from '../../services/http-service/http.service';
import { environment } from '../../../environments/environment';
import { ITestimonial } from '../../models/models.interface';


@Component({
  selector: 'app-testimonials',
  imports: [CommonModule],
  templateUrl: './testimonials.component.html',
  styleUrl: './testimonials.component.scss'
})
export class TestimonialsComponent implements AfterViewInit, OnInit {
  @ViewChild('sectionRef', { static: true }) sectionRef!: ElementRef;

  testimonials: ITestimonial[] = [
    {
      id: '1',
      name: '',
      stars: 0,
      subtitle: '',
      testimonial:'',
      image: ''
    },
    {
      id: '2',
      name: '',
      stars: 0,
      subtitle: '',
      testimonial:'',
      image: ''
    },
    {
      id: '3',
      name: 'Alice Johnson',
      stars: 0,
      subtitle: '',
      image: '',
      testimonial:''
    }
  ]

  activeIndex = 0;

  constructor(private renderer: Renderer2, private http: HttpService) {}

  ngOnInit(): void {
    this.http.get<ITestimonial[]>(`${environment.API_ENDPOINT}/api/home/testimonials`).subscribe(res => {
      this.testimonials = res;
      console.log(res);

    })
  }

  ngAfterViewInit(): void {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.renderer.addClass(entry.target, 'animate-fade-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: '0px', threshold: 0.1 }
    );

    const elements: NodeListOf<HTMLElement> = this.sectionRef.nativeElement.querySelectorAll('.appear-on-scroll');
    elements.forEach(el => observer.observe(el));
  }

  handleNext(): void {
    this.activeIndex = (this.activeIndex + 1) % this.testimonials.length;
  }

  handlePrev(): void {
    this.activeIndex = (this.activeIndex - 1 + this.testimonials.length) % this.testimonials.length;
  }

  getStars(rating: number): number[] {
    return Array(5).fill(0).map((_, i) => i < rating ? 1 : 0);
  }
}
